import { Burger, Header, MediaQuery } from "@mantine/core";
import { useState, useEffect } from "react";
import { Logo } from "./Logo";
import NotificationHeader from "./NotificationHeader";
import {
	unsubscribeToTransactionEvent,
	subscribeToTransactionEvent,
} from "@/lib/subscribe-to-notifications";
import { useNotification } from "@/context/notification-context";

export default function AppHeader() {
	const [isNavOpened, setIsNavOpened] = useState(false);
	const { subscribeToChannel, unSubscribeToChannel } = useNotification();

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		subscribeToTransactionEvent({ subscribeToChannel });
		return () => unsubscribeToTransactionEvent({ unSubscribeToChannel });
	}, []);

	return (
		<>
			<Header
				height={70}
				className="bg-[#24313e] border-b border-b-secondaryBg py-5 px-4"
			>
				<div className="flex gap-x-5 justify-between h-[100%]">
					<MediaQuery largerThan="sm" styles={{ display: "none" }}>
						<Burger
							opened={isNavOpened}
							onClick={() => setIsNavOpened((o) => !o)}
							size="sm"
							color="black"
							mr="xl"
						/>
					</MediaQuery>
					<div className="pl-5">
						<Logo imageWidth={100} leftAlign />
					</div>
					<div>
						<NotificationHeader />
					</div>
				</div>
			</Header>
		</>
	);
}
